/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  getAuthProvider: (state, getters, rootState) => {
    return rootState.AppActiveUser && rootState.AppActiveUser.provider
      ? rootState.AppActiveUser.provider
      : null
  }
}
